export const SVG_CONTENT = `<svg xmlns="http://www.w3.org/2000/svg" width="685"  viewBox="0 0 800 100">
  <text x="190" y="30" font-size="18px" text-anchor="middle" fill="#03c3d7" transform="rotate(-10, 200, 50)">旧版本内容 仅供参考</text>
  <text x="590" y="30" font-size="18px" text-anchor="middle" fill="#03c3d7" transform="rotate(-10, 600, 50)">旧版本内容 仅供参考</text>
</svg>`;

// 浏览时长埋点相关常量
export const BROWSE_MODULE = {
  HOME: 0,        // 首页
  COMMUNITY: 1,   // 社区
  DOCUMENT: 2,    // 文档
  SCHOOL: 3,      // 学堂
  AWARDS: 4,       // 奖品
  ASSISTANT: 5,   // 助手
};

// 页面路径与浏览模块映射
export const PAGE_TO_MODULE_MAP = {
  '/home': BROWSE_MODULE.HOME,
  '/forum': BROWSE_MODULE.COMMUNITY,
  '/wiki': BROWSE_MODULE.DOCUMENT,
  '/learn': BROWSE_MODULE.SCHOOL,
  '/assistant': BROWSE_MODULE.ASSISTANT,
  '/awards': BROWSE_MODULE.AWARDS,
};

// 心跳上报间隔（毫秒）
export const HEARTBEAT_INTERVAL = 2000;

// 浏览时长缓存key
export const BROWSING_CACHE_KEY = 'browsing_duration_cache';

// URL 排除列表（不进行埋点和心跳上报的页面）
export const EXCLUDED_URLS = [
  '/forum',
  '/wiki'
];